var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRedo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 6H8C6.4087 6 4.88258 6.63214 3.75736 7.75736C2.63214 8.88258 2 10.4087 2 12C2 13.5913 2.63214 15.1174 3.75736 16.2426C4.88258 17.3679 6.4087 18 8 18H11C11.5523 18 12 18.4477 12 19C12 19.5523 11.5523 20 11 20H8C5.87827 20 3.84344 19.1571 2.34315 17.6569C0.842855 16.1566 0 14.1217 0 12C0 9.87827 0.842855 7.84344 2.34315 6.34315C3.84344 4.84285 5.87827 4 8 4H12V1.38778C12 0.836683 12.6428 0.535631 13.0661 0.888433L17.4008 4.50066C17.7126 4.76052 17.7126 5.23948 17.4008 5.49934L13.0661 9.11157C12.6428 9.46437 12 9.16332 12 8.61222V6Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedo);
export default __webpack_public_path__ + "static/media/redo.d2d72b78006090eeb6e200a0e0b441b8.svg";
export { ForwardRef as ReactComponent };